import { render, staticRenderFns } from "./note-from.vue?vue&type=template&id=0eb1a10e&scoped=true&"
import script from "./note-from.vue?vue&type=script&lang=js&"
export * from "./note-from.vue?vue&type=script&lang=js&"
import style0 from "./note-from.vue?vue&type=style&index=0&id=0eb1a10e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb1a10e",
  null
  
)

export default component.exports